// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"6dc66360","447":"c659ff85","967":"df5d3202"}[chunkId] + ".chunk.js";
};